import React from "react";
import * as moment from "moment";
import TeamVideoResponsesPopper from "./TeamVideoResponsesPopper";

const styles = {
  teamVideo: {
    marginTop: "10px",
    margin: "5px",
  },
  video: {
    width: "100%",
    background: "#ccc",
    height: "120px",
    objectFit: "cover",
  },
  timeFilter: {
    height: "35px",
  },
  teamVideoHeader: {
    display: "flex",
    padding: "6px",
  },
  teamVideoFooter: {
    display: "flex",
    padding: "5px",
    flexDirection: "column",
    fontSize: "12px",
    position: "relative",
  },
  publishedContainer: {
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  publishButton: {
    backgroundColor: "transparent",
    cursor: "pointer",
    border: "0",
    height: "24px",
    paddingLeft: "37px",
  },
};

export default ({ teamVideo }) => {
  const classes = styles;

  return (
    <div style={classes.teamVideo} key={teamVideo.id} className="sidebar-post">
      <video
        style={classes.video}
        src={teamVideo?.media}
        alt={teamVideo?.topic}
        autoPlay={false}
        preload="metadata"
        controls={false}
      ></video>
      <div
        style={classes.teamVideoFooter}
        className="sidebar-post-content p-3 m-1"
      >
        {/* <div style={classes.publishedContainer}> */}
        <h6>{teamVideo?.published_at ? "Published" : "Not Published"}</h6>
        <div className="color-light fs-12">
          {teamVideo?.published_at
            ? moment(teamVideo.published_at).format("DD/MM/YYYY HH:mm")
            : ""}
        </div>
        {/* </div> */}
        <p>{teamVideo?.topic}</p>
        <div>
          <TeamVideoResponsesPopper teamVideo={teamVideo} />
        </div>
      </div>
    </div>
  );
};
